import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Home = () => {
  const [searchParams] = useSearchParams();
  const [urlParams, setUrlParams] = useState({
    aid: '',
    sid: '',
    tid: ''
  });

  // Capture URL parameters when component mounts
  useEffect(() => {
    const aid = searchParams.get('aid') || '';
    const sid = searchParams.get('sid') || '';
    const tid = searchParams.get('tid') || '';

    // Save to state
    const params = { aid, sid, tid };
    setUrlParams(params);

    // Save to localStorage for persistence
    localStorage.setItem('urlParams', JSON.stringify(params));

    console.log('Captured URL parameters:', params);
  }, [searchParams]);

  const handleAgeClick = () => {
    // Build the URL with captured parameters
    const baseUrl = 'https://www.ls3mg2ez.com/5J4BBT/PLNH5K/';
    const source_id = urlParams.aid || '';
    const sub1 = urlParams.tid || '';
    
    const finalUrl = `${baseUrl}?source_id=${source_id}&sub1=${sub1}`;
    
    console.log('Opening URL:', finalUrl);
    window.location.href = finalUrl;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Top Section - White Background */}
      <div className="bg-white py-3 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-base md:text-lg font-bold text-gray-900 mb-2">
            85729 Drivers Saved On Auto Insurance
          </h1>
          
          {/* Avatar Images */}
          <div className="flex justify-center items-center mb-2">
            <img 
              src="https://storage.googleapis.com/core-new/syCgzCRYSTiAQzRvbTweQIEF-Avatars.png" 
              alt="Happy customers"
              className="h-8 md:h-10 object-contain"
            />
          </div>
        </div>
      </div>

      {/* Blue Section */}
      <div className="bg-[#1a4179] min-h-[calc(100vh-200px)] py-8 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Headline */}
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-2xl lg:text-3xl font-bold text-white mb-4">
              U.S. Drivers: Compare Free Quotes & <span className="text-[#ffc107]">Save Up To 75%</span> On Your Auto Insurance
            </h2>
            <p className="text-base md:text-lg text-white">
              Rates Start At $1 Per Day In <span className="italic text-[#ffc107]">the USA</span>
            </p>
          </div>

          {/* Age Selection Card */}
          <div className="bg-white rounded-2xl p-4 md:p-6 shadow-2xl mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-4">
              Tap Your Age
            </h3>
            
            <div className="grid grid-cols-2 gap-2 md:gap-3">
              <button
                onClick={handleAgeClick}
                className="bg-[#d94845] hover:bg-[#c23d3a] text-white text-lg md:text-xl font-bold py-5 md:py-6 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg"
              >
                UP TO 20
              </button>
              
              <button
                onClick={handleAgeClick}
                className="bg-[#d94845] hover:bg-[#c23d3a] text-white text-lg md:text-xl font-bold py-5 md:py-6 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg"
              >
                20-40
              </button>
              
              <button
                onClick={handleAgeClick}
                className="bg-[#d94845] hover:bg-[#c23d3a] text-white text-lg md:text-xl font-bold py-5 md:py-6 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg"
              >
                41-60
              </button>
              
              <button
                onClick={handleAgeClick}
                className="bg-[#d94845] hover:bg-[#c23d3a] text-white text-lg md:text-xl font-bold py-5 md:py-6 rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg"
              >
                60+
              </button>
            </div>
          </div>

          {/* Average Expenditure */}
          <div className="text-center mb-8">
            <p className="text-white text-base md:text-lg font-semibold">
              Avg. expenditure $89/month
            </p>
          </div>

          {/* Testimonials Section */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-2xl">
            {/* Testimonial 1 */}
            <div className="flex flex-row items-start gap-3 md:gap-4 mb-8 pb-8 border-b border-gray-200">
              <img 
                src="https://insurancesavingscall.com/lander/auto-insurance-408/assets/testimonial1.png" 
                alt="Sarah A. Smythe"
                className="w-16 h-16 md:w-20 md:h-20 rounded-full flex-shrink-0"
              />
              <div className="flex-1">
                <p className="text-gray-800 italic text-xs md:text-base mb-2 md:mb-3">
                  "I used to pay $217/month for car insurance. Now I only pay $67 with full coverage! I thought switching would be complicated, but the agent was clear, patient, and honest. I recommend calling right away!"
                </p>
                <div className="flex gap-1 mb-1 md:mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-base md:text-xl">⭐</span>
                  ))}
                </div>
                <p className="font-bold text-gray-900 text-xs md:text-base">
                  Sarah A. Smythe - Dallas, TX
                </p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="flex flex-row items-start gap-3 md:gap-4 mb-8 pb-8 border-b border-gray-200">
              <img 
                src="https://insurancesavingscall.com/lander/auto-insurance-408/assets/testimonial.png" 
                alt="Peter J. Lewis"
                className="w-16 h-16 md:w-20 md:h-20 rounded-full flex-shrink-0"
              />
              <div className="flex-1">
                <p className="text-gray-800 italic text-xs md:text-base mb-2 md:mb-3">
                  "I was overpaying for years. They helped me save over $150 a month without changing my coverage. Everything was quick, easy, and no pressure I called, and it was the best thing I ever did!"
                </p>
                <div className="flex gap-1 mb-1 md:mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-base md:text-xl">⭐</span>
                  ))}
                </div>
                <p className="font-bold text-gray-900 text-xs md:text-base">
                  Peter J. Lewis - Miami, FL
                </p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="flex flex-row items-start gap-3 md:gap-4">
              <img 
                src="https://insurancesavingscall.com/lander/auto-insurance-408/assets/testimonial2.png" 
                alt="Flossie R. Brown"
                className="w-16 h-16 md:w-20 md:h-20 rounded-full flex-shrink-0"
              />
              <div className="flex-1">
                <p className="text-gray-800 italic text-xs md:text-base mb-2 md:mb-3">
                  "I waited too long. When I finally called, they explained everything and helped me cut my premium nearly in half! If you're thinking about it, do it now."
                </p>
                <div className="flex gap-1 mb-1 md:mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-base md:text-xl">⭐</span>
                  ))}
                </div>
                <p className="font-bold text-gray-900 text-xs md:text-base">
                  Flossie R. Brown - Phoenix, AZ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="bg-white py-12 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Security Badge */}
          <div className="flex justify-center mb-8">
            <div className="bg-[#c8e6c9] border-2 border-[#81c784] rounded-lg px-6 py-3 flex items-center gap-3">
              <svg className="w-6 h-6 text-[#2e7d32]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <p className="text-gray-800 font-medium text-sm md:text-base">
                We keep all your information 100% secure & confidential, always.
              </p>
            </div>
          </div>

          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/3401076f-c596-49ed-9b02-8a01016dea00/public" 
              alt="EasyAutoProtector"
              className="h-16 md:h-20 object-contain"
            />
          </div>

          {/* Description Text */}
          <div className="text-center space-y-3 mb-8">
            <p className="text-gray-700 text-xs md:text-sm leading-relaxed">
              EasyAutoProtector is a premier auto insurance referral service which allows consumers to quickly and effortlessly request quotes from reputable local agencies. EasyAutoProtector does not provide insurance plans directly to consumers nor do we represent any specific providers.
            </p>
            
            <p className="text-gray-700 text-xs md:text-sm leading-relaxed">
              EasyAutoProtector connects consumers to advertisers and insurance agencies only after we've gathered certain criteria from you. Please note the lowest listed rates may not be available from all companies listed.
            </p>
            
            <p className="text-gray-700 text-xs md:text-sm leading-relaxed">
              Your rates may vary based on your coverage limits, deductibles, driving records, type of vehicle, location and other variables.
            </p>
            
            <p className="text-gray-700 text-xs md:text-sm leading-relaxed">
              By using this site, you acknowledge that you have read and agree to the <a href="#" className="text-blue-600 underline">Terms of Service</a> and <a href="#" className="text-blue-600 underline">Privacy Policy</a>.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-600 text-xs md:text-sm">
              Copyright © 2025 EasyAutoProtector.com | All rights reserved | 32-91 30th St, Astoria, NY 11106, USA
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;